import React from 'react'
import PropTypes from 'prop-types'
import { Callout } from 'components/common/callout'
import ReviewMetadataShape from 'components/supplier_show/prop_shapes/reviewMetadata'

const ExpandableHeader = (props) => {
  const renderToggleButton = () => {
    return (
      <button onClick={handleClick} className='pointer-clickable'>
        <i
          className={`fal expand-toggle ${props.expanded ? 'fa-minus' : 'fa-plus'}`}
          title={props.expanded ? 'Collapse' : 'Expand'}
        />
      </button>
    )
  }

  const handleClick = () => props.locked ? handleLockedClick() : props.handleClick()

  const handleLockedClick = () => {
    localStorage.setItem('redirect_to', window.location.href)
    $('#locked-modal').foundation('open')
  }

  const renderTitleContent = () => {
    if (props.locked) {
      return (
        <span onClick={handleLockedClick}>
          <span style={{ verticalAlign: 'middle' }}><i className='fas fa-lock lock-icon' data-testid='lock' /> </span>
          <span style={{ verticalAlign: 'middle' }}>{props.title}</span>
        </span>
      )
    } else {
      return props.title
    }
  }

  const renderSecondaryCallout = () => {
    if (props.secondaryCallout) {
      return (
        <div>
          {props.secondaryCallout}
        </div>
      )
    } else {
      return null
    }
  }

  const renderTitle = () => (
    <div>
      <h2 className='pro-head-6 margin-right-1_5' data-testid={`${props.idText}-header`}>{renderTitleContent()}</h2>
    </div>
  )

  const renderCountData = () => (
    <div className='expandable-header-count-data'>
      <div>
        <Callout callout={props.callout} />
      </div>
      {renderSecondaryCallout()}
    </div>
  )

  const renderActions = () => (
    <div className='expandable-header-actions'>
      {props.editButton}
      {props.rightCallout}
    </div>
  )

  const renderSingleline = () => (
    <div className='expandable-header-content'>
      {renderTitle()}
      {renderCountData()}
      <div className='expandable-header-flex-grow' />
      {renderActions()}
    </div>
  )

  const renderMultiline = () => (
    <div className='expandable-header-content'>
      <div>
        {renderTitle()}
      </div>
      <div className='expandable-header-second-line'>
        {renderCountData()}
        {renderActions()}
      </div>
    </div>
  )

  return (
    <div className='expandable-header'>
      {props.multiline ? renderMultiline() : renderSingleline()}
      <div className='expandable-header-toggle-button'>
        {renderToggleButton()}
      </div>
    </div>
  )
}

ExpandableHeader.propTypes = {
  title: PropTypes.string,
  callout: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.object.isRequired
  ]),
  secondaryCallout: PropTypes.element,
  expanded: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
  locked: PropTypes.bool.isRequired,
  editButton: PropTypes.element,
  rightCallout: PropTypes.node,
  idText: PropTypes.string,
  metadata: ReviewMetadataShape,
  multiline: PropTypes.bool
}

ExpandableHeader.defaultProps = {
  locked: false,
  multiline: false,
  title: null,
  callout: null,
  secondaryCallout: null,
  editButton: null,
  rightCallout: null,
  idText: null,
  metadata: null
}

export default ExpandableHeader
